import { resolveConfidenceVisitorId } from "@helpers/confidenceVisitorId"
import { Confidence } from "@spotify-confidence/sdk"

/**
 * Shared client for A/B tests: resolve flags with `confidence.getFlag`.
 * @public
 */
export const confidence = Confidence.create({
  clientSecret: import.meta.env.VITE_CONFIDENCE_CLIENT_SECRET as string,
  environment: "client",
  region: "eu",
  timeout: 1000,
})

// Set here rather than through the SDK's visitorIdentity() tracker, which the
// flag loader used to call on every run. That tracker re-read the cookie on
// each page load and minted a fresh uuid whenever it found none, so on the iOS
// in-app browsers that drop the cookie mid-document it produced a different
// randomisation unit per page view, which would quietly split any running test.
// resolveConfidenceVisitorId resolves one id per page load and prefers an
// existing one, so a returning visitor stays in the variant they were already
// served.
const visitorId = resolveConfidenceVisitorId()

if (visitorId) confidence.setContext({ visitor_id: visitorId })
